import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { ConfirmProvider } from './components/ConfirmModal/ConfirmModal'
import './styles/index.css'
import './styles/mobile.css'

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('React Error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#1a0f0a',
          color: '#c9a227',
          fontFamily: 'serif',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <h1 style={{ marginBottom: '1rem' }}>⚔️ Something went wrong</h1>
          <p style={{ color: '#c4b599', marginBottom: '1rem' }}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </p>
          <button 
            onClick={() => {
              // Clear localStorage and reload
              localStorage.clear()
              window.location.reload()
            }}
            style={{
              padding: '0.5rem 1.5rem',
              background: '#c9a227',
              color: '#1a0f0a',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontFamily: 'serif',
              fontSize: '1rem'
            }}
          >
            Clear Session & Reload
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
